import React, { useEffect, useState } from 'react';
import { AdminCrudShell, StatusBadge } from '@/components/admin/AdminCrudShell';
import { fetchSports } from '@/lib/api';

const STATUS_OPTIONS = [
  { value: 'active', label: 'Activo' },
  { value: 'inactive', label: 'Inactivo' },
];

export default function AdminSports() {
  return (
    <AdminCrudShell
      title="Deportes"
      subtitle="Catálogo multi-deporte. Activa o desactiva deportes para controlar su visibilidad pública."
      entity="sports"
      testIdPrefix="admin-sports"
      searchPlaceholder="Buscar deporte…"
      initialForm={{ name: '', slug: '', icon: '', icon_url: '', display_order: 0, status: 'active' }}
      columns={[
        { key: 'display_order', label: 'Orden', className: 'tabular-nums w-16' },
        { key: 'name', label: 'Nombre', render: (r) => <span className="font-medium text-[var(--ns-text)]">{r.icon ? <span className="mr-2">{r.icon}</span> : ''}{r.name}</span> },
        { key: 'slug', label: 'Slug', render: (r) => <code className="text-xs text-[var(--ns-text-muted)]">{r.slug}</code> },
        { key: 'status', label: 'Estado', render: (r) => <StatusBadge status={r.status} /> },
      ]}
      formFields={[
        { name: 'name', label: 'Nombre', required: true, placeholder: 'Ej: Fútbol sala' },
        { name: 'slug', label: 'Slug', placeholder: 'Se genera automáticamente si lo dejas vacío', hint: 'URL-friendly: minúsculas, sin acentos, guiones.' },
        { name: 'icon', label: 'Icono (emoji)', placeholder: '⚽' },
        { name: 'icon_url', label: 'Icono URL', placeholder: 'https://…' },
        { name: 'display_order', label: 'Orden de visualización', type: 'number' },
        { name: 'status', label: 'Estado', type: 'select', required: true, options: STATUS_OPTIONS },
      ]}
    />
  );
}
